import { FileType } from '@office-start/document-types';
var fileTypeStringToExtensions;
var extensionToFileType;
export function createFileTypeStringToExtensionsValues() {
    // Note: Sway files don't have file extensions, so they are not included in this mapping.
    fileTypeStringToExtensions = {};
    fileTypeStringToExtensions[FileType[FileType.Excel]] = [
        'xls',
        'xlsx',
        'xlb',
        'xlc',
        'xlsb',
        'xlsm',
        'xlt',
        'xltx',
        'xltm',
        'xlm',
        'xla',
        'xll',
        'xlam',
        'xlw',
        'excel',
        'csv',
    ];
    fileTypeStringToExtensions[FileType[FileType.Visio]] = [
        'vsd',
        'vss',
        'vst',
        'vdx',
        'vsx',
        'vtx',
        'vsl',
        'vsu',
        'vsw',
        'vsdx',
        'vsdm',
        'vssm',
        'vstx',
        'vstm',
    ];
    fileTypeStringToExtensions[FileType[FileType.PowerPoint]] = [
        'ppt',
        'pptx',
        'pot',
        'potx',
        'potm',
        'ppam',
        'ppsx',
        'ppsm',
        'sldx',
        'sldm',
        'ppa',
        'pps',
        'pptm',
        'powerpoint',
    ];
    fileTypeStringToExtensions[FileType[FileType.Word]] = [
        'doc',
        'dot',
        'docx',
        'docm',
        'dotx',
        'dotm',
        'docb',
        'word',
    ];
    fileTypeStringToExtensions[FileType[FileType.Photos]] = [
        'jpg',
        'png',
        'jpeg',
        'gif',
        'svg',
        'bmp',
        'tif',
        'tiff',
        'heic',
    ];
    fileTypeStringToExtensions[FileType[FileType.Outlook]] = ['msg', 'eml'];
    fileTypeStringToExtensions[FileType[FileType.OneNote]] = ['one'];
    fileTypeStringToExtensions[FileType[FileType.Pdf]] = ['pdf'];
    fileTypeStringToExtensions[FileType[FileType.Audio]] = [
        'mp3',
        'm4a',
        'wav',
        'wma',
    ];
    fileTypeStringToExtensions[FileType[FileType.Text]] = ['txt'];
    fileTypeStringToExtensions[FileType[FileType.Fluid]] = ['fluid', 'loop'];
    fileTypeStringToExtensions[FileType[FileType.Stream]] = [
        'mts',
        'm2ts',
        'ts',
        '3g2',
        '3gp',
        '3gp2',
        '3gpp',
        'asf',
        'wmv',
        'avi',
        'm4v',
        'mov',
        'mp4',
        'mp4v',
        'ogg',
        'webm',
        'movie',
        'mkv',
        'mpg',
        'mpeg',
    ];
    fileTypeStringToExtensions[FileType[FileType.Whiteboard]] = ['whiteboard'];
    fileTypeStringToExtensions[FileType[FileType.MeetingNotes]] = ['note'];
    fileTypeStringToExtensions[FileType[FileType.Clipchamp]] = ['clipchamp'];
    fileTypeStringToExtensions[FileType[FileType.Link]] = ['url'];
    fileTypeStringToExtensions[FileType[FileType.Draft]] = ['draft'];
    fileTypeStringToExtensions[FileType[FileType.Planner]] = ['plan'];
    return fileTypeStringToExtensions;
}
function createExtensionToFileTypeValues() {
    if (!fileTypeStringToExtensions) {
        fileTypeStringToExtensions = createFileTypeStringToExtensionsValues();
    }
    extensionToFileType = {};
    var _loop_1 = function (typeName) {
        if (!fileTypeStringToExtensions.hasOwnProperty(typeName)) {
            return "continue";
        }
        var extensions = fileTypeStringToExtensions[typeName];
        if (!extensions) {
            return "continue";
        }
        extensions.forEach(function (ext) {
            extensionToFileType[ext] = FileType[typeName];
        });
    };
    for (var typeName in fileTypeStringToExtensions) {
        _loop_1(typeName);
    }
    return extensionToFileType;
}
export function getFileTypeFromExtension(extension) {
    if (!extensionToFileType) {
        extensionToFileType = createExtensionToFileTypeValues();
    }
    if (!extension) {
        return FileType.None;
    }
    return extensionToFileType[extension.toLowerCase()] || FileType.None;
}
export function getFileExtensionFromFileTypeFull(fileType) {
    if (!fileTypeStringToExtensions) {
        fileTypeStringToExtensions = createFileTypeStringToExtensionsValues();
    }
    return fileTypeStringToExtensions[fileType];
}
//# sourceMappingURL=getFileTypeFromExtension.js.map